export default __webpack_public_path__ + "static/media/img15.09d767e5.jpg";